/* Style by Clariss — winkelwagen-lade (cadeauverpakking, aanbevelingen, snel toevoegen) + mobiele sticky balk. */
(function () {
  const SECTIONS = 'cart-drawer,cart-icon-bubble';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  async function mutate(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECTIONS, sections_url: window.location.pathname }, body)),
    });
    const json = await res.json();
    const d = drawer();
    if (d && json.sections) { d.classList.remove('is-empty'); d.renderContents(json); }
    else if (json.description || json.message) console.warn('[sbc] cart', json.description || json.message);
    return json;
  }

  // Cadeauverpakking aan/uit
  document.addEventListener('change', (e) => {
    const t = e.target.closest('[data-sbc-giftwrap-toggle]');
    if (!t) return;
    t.disabled = true;
    if (t.checked) mutate(window.routes.cart_add_url, { items: [{ id: Number(t.dataset.variantId), quantity: 1 }] });
    else mutate(window.routes.cart_change_url, { id: t.dataset.lineKey, quantity: 0 });
  });

  // Snel toevoegen (aanbevelingen in de lade, "Voeg toe"-knoppen elders)
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sbc-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    b.classList.add('loading');
    mutate(window.routes.cart_add_url, { items: [{ id: Number(b.dataset.variantId), quantity: Number(b.dataset.quantity || 1) }] }).finally(() => {
      b.disabled = false;
      b.classList.remove('loading');
    });
  });

  // Meerdere producten in één keer (combinatieblok)
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sbc-add-many]');
    if (!b) return;
    e.preventDefault();
    let items = [];
    try { items = JSON.parse(b.dataset.sbcAddMany || b.getAttribute('data-sbc-add-many')); } catch (err) { return; }
    if (!items.length) return;
    b.disabled = true;
    mutate(window.routes.cart_add_url, { items }).finally(() => { b.disabled = false; });
  });

  // Shop de look: klik op product → sfeerbeeld wisselt
  document.addEventListener('click', (e) => {
    const item = e.target.closest('[data-sbc-look-item]');
    if (!item || e.target.closest('a, [data-sbc-add]')) return;
    const t = item;
    const grid = t.closest('[data-sbc-look]');
    const main = grid && grid.querySelector('[data-sbc-look-photo] img');
    if (!item || !main || !item.dataset.image) return;
    grid.querySelectorAll('[data-sbc-look-item]').forEach((i) => i.classList.toggle('is-active', i === item));
    main.classList.add('is-swapping');
    const next = new Image();
    next.onload = () => { main.srcset = ''; main.sizes = ''; main.src = item.dataset.image; main.alt = item.dataset.imageAlt || ''; main.classList.remove('is-swapping'); };
    next.src = item.dataset.image;
  });

  // Shop de look: sfeerbeelden alvast laden zodat de wissel direct is
  const preloadLook = () => document.querySelectorAll('[data-sbc-look-item][data-image]').forEach((i) => { const im = new Image(); im.src = i.dataset.image; });
  if ('requestIdleCallback' in window) requestIdleCallback(preloadLook); else setTimeout(preloadLook, 1500);

  // Video-stories: afspelen bij klik (video laadt pas dan), andere pauzeren
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sbc-story-play]');
    if (!btn) return;
    const story = btn.closest('.sbc-story');
    const video = story && story.querySelector('video');
    if (!video) return;
    document.querySelectorAll('.sbc-story.is-playing video').forEach((v) => { if (v !== video) { v.pause(); v.closest('.sbc-story').classList.remove('is-playing'); } });
    if (story.classList.contains('is-playing')) { video.pause(); story.classList.remove('is-playing'); return; }
    story.classList.add('is-playing');
    video.muted = false;
    video.play().catch(() => { video.muted = true; video.play(); });
  });

  // Instafeed: zodra de feed gevuld is, de terugval-foto's verbergen
  const feed = document.querySelector('[data-sbc-instafeed]');
  if (feed) {
    const check = () => { if (feed.children.length) { feed.parentElement.querySelector('.sbc-insta')?.classList.add('sbc-hidden'); return true; } return false; };
    if (!check()) new MutationObserver((m, o) => { if (check()) o.disconnect(); }).observe(feed, { childList: true });
  }

  // USP-balk op mobiel: doorlopende ticker (items verdubbelen voor een naadloze loop)
  const ticker = document.querySelector('[data-sbc-usp-ticker]');
  if (ticker && window.innerWidth < 750 && ticker.children.length) {
    const clones = [...ticker.children].map((c) => c.cloneNode(true));
    clones.forEach((c) => { c.setAttribute('aria-hidden', 'true'); ticker.appendChild(c); });
  }

  // Generieke tabs (combinaties, cadeaugids)
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-sbc-edit-tab]');
    if (!tab) return;
    const list = tab.closest('[role=tablist]');
    const root = list.parentElement;
    list.querySelectorAll('[data-sbc-edit-tab]').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
    root.querySelectorAll(':scope > [role=tabpanel]').forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
  });

  // Aanbevelingen: complementaire producten via de Product Recommendations API, terugval = collectie uit instellingen (server-side gerenderd)
  function loadRecs() {
    const box = document.getElementById('SbcCartRecs');
    if (!box || box.dataset.static) return;
    const pid = box.dataset.productId;
    if (!pid || box.dataset.loaded === pid) return;
    box.dataset.loaded = pid;
    const url = `${box.dataset.url}?section_id=sbc-cart-recommendations&product_id=${pid}&intent=complementary&limit=6`;
    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const list = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sbc-recs-list]');
        if (list && Number(list.dataset.count) > 0) box.replaceChildren(list);
      })
      .catch(() => {});
  }
  const observeDrawer = () => {
    const d = drawer();
    if (!d) return;
    loadRecs();
    new MutationObserver(() => loadRecs()).observe(d, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeDrawer);
  else observeDrawer();

  // Mobiele sticky balk: zichtbaar zodra de bezoeker voorbij de eerste sectie (hero) is
  const bar = document.querySelector('[data-sbc-mobile-bar]');
  if (bar) {
    const first = document.querySelector('#MainContent .shopify-section');
    const offset = () => (first ? first.offsetTop + first.offsetHeight : Number(bar.dataset.offset || 600));
    const update = () => {
      const show = window.scrollY > offset() - 40;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('sbc-has-mobile-bar', show);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // Footer-linklijsten inklappen op mobiel
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.sbc-footer-toggle__btn');
    if (!b || window.innerWidth >= 750) return;
    const list = document.getElementById(b.getAttribute('aria-controls'));
    if (!list) return;
    const open = !list.classList.contains('is-open');
    list.classList.toggle('is-open', open);
    b.setAttribute('aria-expanded', String(open));
  });

  // Hover-foto van productkaarten pas laden bij eerste hover (alleen apparaten met muis)
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('pointerover', (e) => {
      const card = e.target.closest && e.target.closest('.sbc-card');
      if (!card) return;
      const img = card.querySelector('img[data-srcset]');
      if (img) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
    }, { passive: true });
  }
})();
